export const ROUTES = {
  base: "/",
  providerSelection: "/provider-selection",
  eligibilityCheck: {
    pendingEligibilityCheck: "/eligibility-check/pending",
    failedEligibilityCheck: "/eligibility-check/failed",
    successEligibilityCheck: "/eligibility-check/success",
  },
  signUp: "/sign-up",
  testPixel: "/test-pixel", // Add this for testing Facebook Pixel
  adminProviderSearch: "/backoffice/provider-search",
  adminSignUp: "/backoffice/sign-up",
  adminProviderSelection: "/backoffice/provider-selection",
  notFound: "*",
} as const;
